import getAppName from '@/composables/widget-view-manager/widget-apps'
import type { Message, WorkflowStatus } from '../frames'
import type { WorkflowExecutionPhase } from '@/embed/types'
import type { ViewState } from '../../view-state'

const workflowPhaseDict: Record<WorkflowStatus, WorkflowExecutionPhase> = {
    CREATED: 'init',
    RUNNING: 'running',
    COMPLETED: 'completed',
    AWAITING: 'init',
    FAILED: 'failed',
    TIMEOUT: 'failed',
    TERMINATED: 'failed',
    PAUSED: 'failed',
    CANCELLED: 'failed',
}

const WORKFLOW_FINISH_STATUSES: WorkflowStatus[] = ['COMPLETED', 'AWAITING', 'FAILED']

export const getWorkflowExecutionPhase = (workflowStatus?: WorkflowStatus): WorkflowExecutionPhase | undefined => {
    return workflowStatus ? workflowPhaseDict[workflowStatus] : undefined
}

export const websocketViewState = (message: Message): ViewState => ({
    view: getAppName(message.taskName || message.taskType, message.providerName) || undefined,
    phase: getWorkflowExecutionPhase(message.workflowStatus),
    terminal: false,
    context: {
        partyId: message.partyId,
        taskId: message.taskId,
        taskDefinitionId: message.taskDefinitionId,
        taskName: message.taskName,
        taskStatus: message.taskStatus,
        taskType: message.taskType,
        when: message.when,
        workflowId: message.workflowId,
        workspaceId: message.workspaceId,
    },
    ref: { id: message.taskId },
    raw: message,
})

export const websocketFirstViewState = (message: Message): ViewState => {
    if (message.workflowStatus === 'COMPLETED') {
        return { ...websocketViewState(message), view: 'workflow-finish', terminal: true }
    }

    if (message.workflowStatus === 'FAILED') {
        return { ...websocketViewState(message), view: undefined, terminal: true }
    }

    return websocketViewState(message)
}

export const websocketNextViewState = (message: Message): ViewState => {
    const state = websocketViewState(message)

    return WORKFLOW_FINISH_STATUSES.includes(message.workflowStatus)
        ? { ...state, view: 'workflow-finish' }
        : state
}
